var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 31.5,
    height: 25.2,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.494 26.254c-1.068-1.608 10.373-1.187 9.776 0-.398.792-.195 2.54.61 5.246H9.9c1.108-2.425 1.306-4.174.594-5.246z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.96 23.37c0 .612-.5 1.11-1.116 1.11H1.836A1.114 1.114 0 01.72 23.37V1.83c0-.612.5-1.11 1.116-1.11h28.008c.615 0 1.116.498 1.116 1.11v21.54zm-10.14 7.397a.4.4 0 01-.34.193H11.2a.4.4 0 01-.34-.193.41.41 0 01-.018-.395c.62-1.255.935-2.859.935-4.766 0-.224.18-.406.4-.406h7.325c.221 0 .4.182.4.406 0 1.907.315 3.51.936 4.766a.41.41 0 01-.018.395zM2.428 0A2.43 2.43 0 000 2.427v20.761a2.43 2.43 0 002.428 2.427h8.358c.184 0 .332.149.332.332 0 2.881-.994 3.97-1.422 4.305a.33.33 0 01-.204.07H6.744a.68.68 0 000 1.358h18.193a.68.68 0 000-1.358H22.18a.33.33 0 01-.205-.07c-.424-.333-1.412-1.418-1.412-4.305 0-.183.149-.332.332-.332h8.359a2.43 2.43 0 002.427-2.427V2.428A2.43 2.43 0 0029.253 0H2.428z",
    fill: "#242726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16 10.818h4.324a.367.367 0 00.366-.366V6.129c0-.395.32-.715.715-.715h2.162c.395 0 .715.32.715.715v4.323c0 .202.164.366.366.366h4.323c.396 0 .715.32.715.715v2.161c0 .395-.32.715-.715.715h-4.323a.367.367 0 00-.366.366V19.1c0 .395-.32.715-.715.715h-2.162a.715.715 0 01-.715-.715v-4.324a.367.367 0 00-.366-.366H9.161a.714.714 0 01-.715-.715v-2.161c0-.395.32-.715.715-.715z",
    stroke: "#000",
    strokeWidth: 0.72
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D3AEB2",
    strokeWidth: 0.7,
    fill: "#FFF",
    cx: 9.982,
    cy: 9.982,
    r: 9.632
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Prata-Regular, Prata",
    fontSize: 10,
    fill: "#88456E"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.195,
    y: 13.48
  }, "1")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.7cbe55e005ed0d3e2de6bbc2b310b205.svg";
export { ForwardRef as ReactComponent };